import { API_URLS } from "../../../utils/api-constants";

export const WORD_CLOUD_SHEET_ID =
  "15AvzpFoU208zP7CyCFjlf4AKnBTnKJEZ-wU0n7HpX0s/Sheet1";

export const STOP_LIST_URL = `${API_URLS.STATIC_SHEETS}/${WORD_CLOUD_SHEET_ID}`;
export const UPDATE_INTERVAL = 10 * 1000; // 10s
